import { camelize } from '@ember/string';
import { Promise } from 'rsvp';
import Service, { inject as service } from '@ember/service';
import { handleErrorResponseWithModal } from 'sh-www/utils/handles-errors';

/**
 * Service for project-line-item related API calls.
 */
export default Service.extend({
  api: service(),
  shData: service(),

  /**
   * create a new project line item
   *
   * @param {Application} application
   * @param {String} type     of type PROJECT_LINE_ITEM.TYPES
   * @param {Number} amount
   * @param {String} description
   * @param {Array<String>=} opt_includes
   * @return {Ember.RSVP.Promise}
   */
  createProjectLineItem(application, type, amount, description, opt_includes = []) {
    let options = {
      jsonData: {
        'amount' : amount,
        'description': description,
        'type' : type
      }
    };

    this.shData.addIncludesToOptions(options, opt_includes);

    return new Promise((resolve, reject) => {
      this.get('api').post(`/applications/${application.get('id')}/project-line-items`, options).then(newLineItem => {
        resolve(newLineItem);
      }).catch(e => {
        handleErrorResponseWithModal(
          this,
          e,
          'There was an error adding your line item to the application. Please refresh and try again.',
          'createProjectLineItem -- error adding line item for app id: ' + application.get('id'),
        );

        reject(e);
      });
    });
  },

  /**
   * Delete a project line item
   *
   * @param {Application} application
   * @param {ProjectLineItem} projectLineItem
   * @return {Ember.RSVP.Promise}
   */
  deleteProjectLineItem(application, projectLineItem) {
    let options = {};
    this.shData.addIncludesToOptions(options, []);

    return new Promise((resolve, reject) => {
      this.get('api').delete(`/applications/${application.get('id')}/project-line-items/${projectLineItem.get('id')}/`, options
      ).then(newLineItem => {
        resolve(newLineItem);
      }).catch(e => {
        handleErrorResponseWithModal(
          this,
          e,
          'There was an error deleting your line item to the application. Please refresh and try again.',
          'createProjectLineItem -- error adding line item for app id: ' + application.get('id'),
        );

        reject(e);
      });
    });
  },

  /**
   * update a project line item
   *
   * @param {Application} application
   * @param {ProjectLineItem} projectLineItem
   * @param {Number} amount
   * @param {String} description
   * @param {String[]} opt_includes           Optional include items for the line item.
   *
   * @return {Ember.RSVP.Promise}
   */
  updateProjectLineItem(application, projectLineItem, amount, description, opt_includes = []) {
    const options = {
      jsonData: {
        'amount' : amount,
        'description': description,
      }
    };

    this.shData.addIncludesToOptions(options, opt_includes);
    return this.api.put(`/applications/${application.id}/project-line-items/${projectLineItem.id}/`, options);
  },
});
